import { useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { companion } from "@/context/CompanionAuthContext";
import { useCompanionAuth } from "@/context/CompanionAuthContext";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const CompanionNewNotice = () => {
  const { user, ready } = useCompanionAuth();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [isPinned, setIsPinned] = useState(false);
  const [busy, setBusy] = useState(false);

  if (ready && user?.role !== "admin") return <Navigate to="/companion" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await companion.post("/notices", { title, body, is_pinned: isPinned });
      toast.success("Notice posted.");
      navigate("/companion/notices", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't post notice.");
    } finally { setBusy(false); }
  };

  return (
    <div className="px-4 py-5 space-y-4" data-testid="companion-new-notice-page">
      <Link to="/companion/notices" className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] text-crest-green font-medium">
        <ArrowLeft className="h-3.5 w-3.5" /> Back
      </Link>
      <header>
        <p className="text-xs uppercase tracking-[0.22em] text-crest-gold font-medium">Admin</p>
        <h1 className="mt-1 font-display text-2xl font-bold text-crest-navy">Post a notice</h1>
      </header>

      <form onSubmit={submit} className="space-y-4 rounded-lg bg-white border border-border p-5">
        <div>
          <label className="text-xs uppercase tracking-[0.14em] text-crest-navy/70 font-medium">Title *</label>
          <Input value={title} onChange={(e) => setTitle(e.target.value)} required className="mt-2 h-11" data-testid="new-notice-title" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.14em] text-crest-navy/70 font-medium">Message *</label>
          <Textarea rows={6} value={body} onChange={(e) => setBody(e.target.value)} required className="mt-2" data-testid="new-notice-body" />
        </div>
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={isPinned} onChange={(e) => setIsPinned(e.target.checked)} data-testid="new-notice-pin" />
          <span>Pin to top of the noticeboard</span>
        </label>
        <button type="submit" disabled={busy} className="w-full h-12 inline-flex items-center justify-center gap-2 rounded-md bg-crest-green text-white font-semibold disabled:opacity-60" data-testid="new-notice-submit">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}
          Post notice
        </button>
      </form>
    </div>
  );
};

export default CompanionNewNotice;
